(() => {
  const LOG = "[JP Seal+Bundle]";
  const DEBUG = true;
  const log = (...a) => DEBUG && console.log(LOG, ...a);

  // Optional: adjust these if your promos change
  const SUB_SAVE = 15;
  const BUNDLE_SAVE = 15; // Fast Bundle
  const TOTAL_SAVE = SUB_SAVE + BUNDLE_SAVE; // "up to 30%"

  function findSubscribeBox() {
    // The "Subscribe & save" option container (usually first selling plan group)
    return document.querySelector('.sls-option-container[data-selling-plan-group]');
  }

  function findIntervalRow(subBox) {
    // Where "Deliver every..." lives
    return subBox?.querySelector(".sls-selling-plan-group-options");
  }

  function buildAddonHeader() {
    const el = document.createElement("div");
    el.className = "jp-sub-bundle-addon__header";
    el.innerHTML = `
      <div class="jp-sub-bundle-addon__title">Get our best value subscriber price</div>
      <div class="jp-sub-bundle-addon__subtitle">
        Step 2: Add any 2+ more items for <strong>extra ${BUNDLE_SAVE}% off</strong>
        <span class="jp-sub-bundle-addon__pill">Up to ${TOTAL_SAVE}% total</span>
      </div>
    `;
    return el;
  }

  function moveChipIntoSubscribe() {
    const chipWrap = document.querySelector(".jp-bundle-chip-wrap");
    if (!chipWrap) return;

    const subBox = findSubscribeBox();
    const anchor = findIntervalRow(subBox);
    if (!subBox || !anchor) return;

    // Ensure our explainer exists once
    if (!subBox.querySelector(".jp-sub-bundle-addon__header")) {
      anchor.insertAdjacentElement("afterend", buildAddonHeader());
    }

    // Move chip directly under the explainer (inside the subscribe option)
    const header = subBox.querySelector(".jp-sub-bundle-addon__header");
    if (header && chipWrap.parentElement !== subBox) {
      header.insertAdjacentElement("afterend", chipWrap);
    } else if (header && chipWrap.previousElementSibling !== header) {
      header.insertAdjacentElement("afterend", chipWrap);
    }

    // mark so we don't fight re-renders unnecessarily
    chipWrap.dataset.jpMovedIntoSeal = "1";
    log("Bundle chip placed inside Subscribe box ✅");
  }

  // Try repeatedly (Seal widget can render after page load / variant change)
  let tries = 0;
  const t = setInterval(() => {
    moveChipIntoSubscribe();
    tries++;
    if (tries > 40) clearInterval(t);
  }, 250);

  // Re-run on variant changes / selling plan re-renders
  document.addEventListener("change", (e) => {
    if (e.target.closest('form[action*="/cart/add"]')) {
      setTimeout(moveChipIntoSubscribe, 300);
      setTimeout(moveChipIntoSubscribe, 800);
    }
  });

  // Also re-run when Seal toggles between one-time/sub (it may rebuild DOM)
  document.addEventListener("click", (e) => {
    if (e.target.closest(".sls-option-container")) {
      setTimeout(moveChipIntoSubscribe, 300);
    }
  });
})();